import { RegionProps } from '@/models/props/LocalizationProps';

const Region: RegionProps = {
    pl: 'poland',
    de: 'germany',
    en: 'england',
    hu: 'hungary',
    ro: 'romania'
};

export default Region;
